import { render, staticRenderFns } from "./inspectionSelections.vue?vue&type=template&id=66c0df54&scoped=true&"
import script from "./inspectionSelections.vue?vue&type=script&lang=ts&"
export * from "./inspectionSelections.vue?vue&type=script&lang=ts&"
import style0 from "./inspectionSelections.vue?vue&type=style&index=0&id=66c0df54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c0df54",
  null
  
)

export default component.exports